import React, { useState } from "react";
import NormalInputField from "../../../../components/inputs/NormalInputField";
import NormalSelectInputField from "../../../../components/inputs/NormalSelectInputField";
import countries from "../../../../../countries.json";
import Spinner from "../../../../components/spinners/Spinner";
import { useLoaderData } from "react-router-dom";
import instance from "../../../../axios/instance";
import { getToken } from "../../../../utils/token";
import { DEAInput, NPIInput } from "../../../../components/inputs/InputField";
import { CreditCard } from "lucide-react";
import CardInfoModal from "../../../../components/modals/CardModal";

export const facilityIndexLoader = async ({ params }) => {
  const token = getToken();
  const doctor = await instance.get("/doctor", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const res = await instance.get("/doctor/facility", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return { facility: res.data, doctor: doctor.data };
};

export const IndexPage = () => {
  const { facility, doctor } = useLoaderData();
  const [facilityName, setFacilityName] = useState(facility.name || "");
  const [address1, setAddress1] = useState(facility.address1 || "");
  const [address2, setAddress2] = useState(facility.address2 || "");
  const [city, setCity] = useState(facility.city || "");
  const [state, setState] = useState(facility.state || "");
  const [country, setCountry] = useState(facility.country || "");
  const [zipCode, setZipCode] = useState(facility.zipcode || "");
  const [facilityCode, setFacilityCode] = useState(
    facility.facility_code || "",
  );
  const [facilityTypeCode, setFacilityTypeCode] = useState(
    facility.facility_type || "",
  );
  const [contactName, setContactName] = useState(facility.contact_name || "");
  const [officePhone, setOfficePhone] = useState(facility.office_phone || "");
  const [homePhone, setHomePhone] = useState(facility.home_phone || "");
  const [fax, setFax] = useState(facility.fax || "");
  const [email, setEmail] = useState(facility.email || "");
  const [website, setWebsite] = useState(facility.website || "");
  const [taxID, setTaxID] = useState(facility.tax_id || "");
  const [npiNumber, setNpiNumber] = useState(facility.npi_number || "");
  const [deaNumber, setDeaNumber] = useState(facility.dea_number || "");
  const [taxonomyCode, setTaxonomyCode] = useState(
    facility.taxonomy_code || "",
  );
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [openCardModal, setOpenCardModal] = useState(false);

  const getStates = () => {
    if (country) {
      const _country = countries.find(
        (_country) => _country.name.toLowerCase() === country.toLowerCase(),
      );
      return _country ? _country.states.map((state) => state.name) : [];
    }
    return [];
  };

  const btnDisabled =
    !facilityName ||
    !address1 ||
    !city ||
    !state ||
    !country ||
    !zipCode ||
    !facilityCode ||
    !facilityTypeCode ||
    npiNumber.length < 10 ||
    deaNumber.length < 9;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");
    const token = getToken();
    setLoading(true);
    instance
      .put(
        "/doctor/facility/edit",
        {
          email,
          name: facilityName,
          website,
          homePhone,
          officePhone,
          contactName,
          address1,
          address2,
          taxId: taxID,
          taxonomyCode,
          fax,
          facilityTypeCode,
          facilityCode,
          zipCode,
          city,
          state,
          country,
          npiNumber,
          deaNumber,
          id: facility.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        setLoading(false);
        setSuccess(true);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error.response.data);
        setErrorMessage(error.response.data.message);
        setLoading(false);
      });
  };
  const disabledAll = doctor.access !== "admin";
  return (
    <>
      <form onSubmit={handleFormSubmit}>
        <div className="px-7 py-10 grid grid-cols-1 gap-y-10 lg:grid-cols-[auto_30%] gap-x-10 items-start">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-6 border-b pb-10 lg:border-r lg:pr-10 lg:border-b-0 lg:pb-0">
            <NormalInputField
              disabled={disabledAll}
              title="Facility Name"
              isRequired={true}
              type="text"
              onChange={(e) => setFacilityName(e.target.value)}
              value={facilityName}
            />
            <NormalInputField
              disabled={disabledAll}
              title="Address Line 1"
              type="text"
              isRequired={true}
              onChange={(e) => setAddress1(e.target.value)}
              value={address1}
            />
            <NormalInputField
              disabled={disabledAll}
              title="Address Line 2"
              type="text"
              isRequired={false}
              onChange={(e) => setAddress2(e.target.value)}
              value={address2}
            />
            <NormalSelectInputField
              disabled={disabledAll}
              title="Country"
              isRequired={true}
              values={countries.map((country) => country.name)}
              onChange={(e) => setCountry(e.target.value)}
              value={country}
            />

            <NormalSelectInputField
              disabled={disabledAll}
              title="State"
              isRequired={true}
              values={getStates()}
              onChange={(e) => setState(e.target.value)}
              value={state}
            />
            <NormalInputField
              disabled={disabledAll}
              title="City"
              type="text"
              isRequired={true}
              onChange={(e) => setCity(e.target.value)}
              value={city}
            />
            <NormalInputField
              disabled={disabledAll}
              title="Zip Code"
              isRequired={true}
              type="text"
              onChange={(e) => setZipCode(e.target.value)}
              value={zipCode}
            />
            <NormalInputField
              disabled={disabledAll}
              title="Website"
              type="text"
              isRequired={false}
              onChange={(e) => setWebsite(e.target.value)}
              value={website}
            />

            <NormalInputField
              disabled={disabledAll}
              title="Faciliy Code"
              type="text"
              isRequired={true}
              onChange={(e) => setFacilityCode(e.target.value)}
              value={facilityCode}
            />
            <NormalSelectInputField
              disabled={disabledAll}
              title="Facility Type"
              isRequired={true}
              values={[
                { value: "hospital", label: "Hospital" },
                { value: "clinic", label: "Clinic" },
              ]}
              onChange={(e) => setFacilityTypeCode(e.target.value)}
              value={facilityTypeCode}
            />

            <NormalInputField
              disabled={disabledAll}
              title="Tax ID"
              type="text"
              isRequired={false}
              onChange={(e) => setTaxID(e.target.value)}
              value={taxID}
            />
            <NormalInputField
              disabled={disabledAll}
              title="Taxonomy Code"
              type="text"
              isRequired={false}
              onChange={(e) => setTaxonomyCode(e.target.value)}
              value={taxonomyCode}
            />
            <DEAInput
              title="DEA Number"
              isRequired={true}
              value={deaNumber}
              onChange={(e) => setDeaNumber(e.target.value)}
              disabled={disabledAll}
            />
            <NPIInput
              title="NPI Number"
              isRequired={true}
              value={npiNumber}
              onChange={(e) => setNpiNumber(e.target.value)}
              disabled={disabledAll}
            />
          </div>
          <div>
            <div className="font-bold text-[16px] mb-5">
              Contact Person Information
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-y-5 gap-x-3">
              <NormalInputField
                disabled={disabledAll}
                title="Name"
                type="text"
                isRequired={false}
                onChange={(e) => setContactName(e.target.value)}
                value={contactName}
              />
              <NormalInputField
                disabled={disabledAll}
                title="Office Phone"
                type="text"
                isRequired={false}
                onChange={(e) => setOfficePhone(e.target.value)}
                value={officePhone}
              />
              <NormalInputField
                disabled={disabledAll}
                title="Mobile Phone"
                type="text"
                isRequired={false}
                onChange={(e) => setHomePhone(e.target.value)}
                value={homePhone}
              />
              <NormalInputField
                disabled={disabledAll}
                title="Email"
                type="text"
                isRequired={false}
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
            </div>
            {/* Card Details Section */}
            <div className="mt-8 pt-6 border-t">
              <div className="font-bold text-[16px] mb-3">
                Clinic Card Details
              </div>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-5 space-y-4">
                <div className="space-y-1">
                  <div className="font-medium text-gray-900 text-sm flex items-center gap-2">
                    <CreditCard size={18} className="text-primary" />
                    <span>Payment & Billing Card</span>
                  </div>
                  <p className="text-xs text-gray-500">
                    Input or update your credit/debit card information used for
                    subscriptions and prescription order payments.
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => setOpenCardModal(true)}
                  className="cursor-pointer bg-primary text-white hover:opacity-90 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md font-medium text-[13px] shadow-sm transition-all whitespace-nowrap self-start sm:self-auto"
                >
                  <CreditCard size={16} />
                  <span>Update Card Details</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="p-3 border-t">
          {!disabledAll && (
            <div className="flex justify-between gap-2 items-center">
              <button
                disabled={btnDisabled}
                type="submit"
                className={`cursor-pointer bg-primary text-white disabled:cursor-not-allowed disabled:opacity-50 min-w-[200px] flex justify-center items-center py-3 px-3 shadow-sm rounded-[4px] font-semibold text-[14px]`}
              >
                {loading ? (
                  <span className="px-10 block">
                    <Spinner color="white" />
                  </span>
                ) : (
                  "Save changes"
                )}
              </button>
            </div>
          )}
          <div className="font-semibold text-[tomato] text-left text-[14px] mt-2">
            {errorMessage}
          </div>
          {success && (
            <div className="font-semibold text-[#3caf50] text-left text-[14px] mt-2">
              Facility information updated
            </div>
          )}
        </div>
      </form>

      {openCardModal && (
        <CardInfoModal
          open={openCardModal}
          isOpen={openCardModal}
          onClose={() => setOpenCardModal(false)}
          address={address1}
          zipcode={zipCode}
          name={`${contactName}`.trim()}
          type={"clinic"}
          facilityId={facility.id}
        />
      )}
    </>
  );
};
